<script lang="ts">
  /** A room state with nothing to do but wait for other players. */
  interface Props {
    title: string;
    message: string;
    /** Announce the message as a live status (it changes by itself). */
    status?: boolean;
  }
  let { title, message, status = false }: Props = $props();
</script>

<section class="screen">
  <h1>{title}</h1>
  <p role={status ? 'status' : undefined}>{message}</p>
</section>
